// extracted by mini-css-extract-plugin
module.exports = {"ModalHeaderTextContainer":"v9c3FqNbI-Y9fWbwO13IJw==","ModalBodyContainer":"+G0hiqResDqbE2FGfsrriw=="};